import { initializeApp } from 'firebase/app';
import { getAuth, EmailAuthProvider, onAuthStateChanged } from 'firebase/auth'; // ✅ moved up here
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

// NEW IMPORTS ADDED FOR THE MATCHING SYSTEM
import { doc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Initialize FirebaseUI
export const ui = new firebaseui.auth.AuthUI(auth);

// Configure FirebaseUI
export const uiConfig = {
    signInOptions: [
        {
            provider: EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: true
        }
    ],
    signInFlow: 'popup',
    callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
            return false;
        }
    },
    credentialHelper: firebaseui.auth.CredentialHelper.NONE
};

// =======================
// New code added for Hiking Buddy Matching System
// =======================

/**
 * Sets the user's searching status in Firestore.
 * @param {string} userId - The user's unique ID.
 * @param {boolean} isSearching - True if the user is searching for a hiking buddy.
 * @param {string} [trailId] - The trail ID for which the user is searching.
 */
export async function setUserSearching(userId, isSearching, trailId) {
    const userDocRef = doc(db, 'users', userId);
    if (isSearching) {
        // When searching, store which trail they are looking for
        await updateDoc(userDocRef, { 
            isSearchingForHikingBuddy: true,
            searchingTrailId: trailId
        });
    } else {
        // When NOT searching, reset to false and remove the trail ID
        await updateDoc(userDocRef, { 
            isSearchingForHikingBuddy: false,
            searchingTrailId: null
        });
    }
}

/**
 * Fetches all users currently searching for a hiking buddy for a specific trail.
 * @param {string} trailId - The trail ID to filter by.
 * @returns {Promise<Array>} - An array of user objects.
 */
export async function fetchSearchingUsers(trailId) {
    const usersRef = collection(db, 'users');
    const q = query(
        usersRef, 
        where('isSearchingForHikingBuddy', '==', true),
        where('searchingTrailId', '==', trailId)
    );
    const querySnapshot = await getDocs(q);
    const users = [];
    querySnapshot.forEach((docSnapshot) => {
        users.push({ id: docSnapshot.id, ...docSnapshot.data() });
    });
    return users;
}
